module.exports = __webpack_public_path__ + "a054362a7942d7951c8ef5d8e10cc0e9.pdf";